var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var Document = require('../../models/document-model');
var DeleteConfirmationModal = require('../common/delete-confirmation-modal');
var SetDocumentDueForm = require("./set-document-due-form");
var DocumentMetaModal = require('./document-meta-modal');

var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');


var DocumentData = Marionette.View.extend({
    template: require('../../templates/documents/document-data.html'),

    model: new Document(),

    regions: {
        removeConfirmationModal: '.delete-confirmation-modal',
        setDueFormModal: '#set-due-form-modal',
        addMetaFormRegion: '#add-meta-form'
    },

    ui: {
        editDueTime: '#edit-due-time',
        dueTimeLabel: '#due-time',
        createdDate: "#created-date",
        saveCreatedDate: "#save-created-date",
        cancelCreatedDate: '#cancel-created-date',
        createdDateForm: '#created-date-form',
        editCreatedTime: '#edit-created-time',
        createdDateDisplay: '#created-date-display',
        createdDateDisplayContainer: '#created-date-display-container',

        addEditMetadata: '#add-edit-metadata'
    },

    events: {
        'click #remove-document': 'removeDocument',
        'click @ui.editDueTime': 'onEditDueTime',
        'click @ui.saveCreatedDate': 'saveCreatedDate',
        'click @ui.cancelCreatedDate': 'cancelCreatedDate',
        'click @ui.editCreatedTime': 'editCreatedTime',

        'click @ui.addEditMetadata': 'addEditMetadata'
    },

    childViewEvents: {
        'delete:confirmed': 'deleteConfirmed',
        'due:set:to:document': 'onDueSet'
    },

    constants: {
        addMetaTitle: 'Add metadata',
        editMetaTitle: 'Edit metadata'
    },

    templateContext: function () {
        var that = this;
        var uploaderPersonName = (that.model.get('relations') || []).filter(function(item) {
            return item.parentId == that.model.get('id') && item.systemRelationType == 'DOCUMENT_UPLOADER_PERSON';
        }).map(function(item) {
            return item.child ? that.utils.formatPerson(item.child.object) : '';
        });
        return {
            fmUploadedTime: that.utils.longToDateTimeFormatted(that.model.get('createdTime'), "MM/DD/YYYY hh:mm A"),
            fmCreatedTime: that.utils.longToDateTimeFormatted(that.model.get('object').createdTime, "MM/DD/YYYY hh:mm A"),
            fmDueTime: that.model.get('object').dueDate === 0 ? '' : that.utils.longToDateTimeFormatted(that.model.get('object').dueDate, "MM/DD/YYYY hh:mm A"),
            fmSignedTime: that.utils.longToDateTimeFormatted(that.model.get('object').signedTime, "MM/DD/YYYY hh:mm A"),
            canEdit: that.canEdit,
            canUploadForOrganizationInDocument: that.canUploadForOrganizationInDocument,
            status: that.utils.getDocumentStatus(that.model.get('object').status),
            intention: that.utils.getIntention(that.model.get('object').intention || "UNASSIGNED"),
            uploaderId: that.model.get('object').uploaderPersonId,
            uploaderName: _.isEmpty(uploaderPersonName) ? "" : uploaderPersonName,
            isMd: that.getOption('isMd'),
            isDocumentCreator: (that.model.get('createdBy') || {}).id == that.getOption('userId'),
            byAdmin: that.getOption('byAdmin')
        }
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
        this.model = options.model;
        this.canEdit = options.canEdit;
        this.canUploadForOrganizationInDocument = options.canUploadForOrganizationInDocument;
        this.createdDate = this.model.get('object').createdTime;
    },

    onRender: function () {
        var that = this;
        this.showChildView('removeConfirmationModal',
            new DeleteConfirmationModal({
                message: 'Enter: "confirm" if you agree to remove the document.',
                confirmationAnswer: 'confirm'
            }));
        this.ui.createdDate.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A',
            defaultDate: that.utils.getDateWithoutTime(new Date(that.model.get('object').createdTime))
        });
        that.ui.createdDate.on("dp.change", function (e) {
            if (e.date) {
                that.createdDate = e.date.valueOf();
            } else {
                that.createdDate = 0;
            }
        });

        that.checkAndGetMetadata();
    },

    removeDocument: function () {
        this.$('#delete-confirmation-modal').modal();
    },

    deleteConfirmed: function (value) {
        if (value == true) {
            var that = this;
            this.model.destroy({
                dataType: "text",
                success: function () {
                    that.remove();
                    that.unbind();
                    Backbone.history.navigate('/documents', {
                        trigger: true
                    });
                }
            });
        }
    },

    onEditDueTime: function () {
        var that = this;
        that.showChildView('setDueFormModal', new SetDocumentDueForm({
            docIds: [this.model.get('id')]
        }));
    },

    onDueSet: function (data) {
        if (data.documentsIdWithErrors && data.documentsIdWithErrors.length > 0) {
            $.notify("You do not have permissions for update this document", "error");
        } else {
            this.ui.dueTimeLabel.text(this.utils.longToDateTimeFormatted(data.selectedDate, "MM/DD/YYYY hh:mm A"));
        }
    },

    editCreatedTime: function () {
        this.ui.createdDateForm.show();
        this.ui.createdDateDisplayContainer.hide();
    },

    saveCreatedDate: function () {
        var that = this;
        this.utils.showSpinner("#save-loader");
        $.ajax({
            type: "POST",
            url: '/api/document/' + that.model.get('id') + '/created/' + that.createdDate,
            contentType: 'application/json',
            statusCode: {
                200: function () {
                    that.utils.hideSpinner("#save-loader");
                    that.ui.createdDateForm.hide();
                    that.ui.createdDateDisplayContainer.show();
                    that.ui.createdDateDisplay.html(that.utils.longToDateTimeFormatted(that.createdDate, "MM/DD/YYYY hh:mm A"));
                }
            },
            error: function (e) {
                that.utils.hideSpinner("#save-loader");
                that.ui.createdDateForm.hide();
                that.ui.createdDateDisplayContainer.show();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    cancelCreatedDate: function () {
        this.ui.createdDateForm.hide();
        this.ui.createdDateDisplayContainer.show();
    },

    addEditMetadata: function () {
        var that = this;

        that.showChildView('addMetaFormRegion', new DocumentMetaModal({
            documentId: that.model.get('id'),
            meta: that.metadata ? that.metadata.meta : that.utils.initialMeta(),
            metadataId: that.metadata ? that.metadata.id : null,
            successCallback: function () {
                that.checkAndGetMetadata()
            }
        }));
    },

    checkAndGetMetadata: function () {

        var that = this;

        $.ajax({
            type: "GET",
            url: '/api/document/meta/' + that.model.get('id'),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.ui.addEditMetadata.text(that.constants.editMetaTitle);
                    that.metadata = response;
                },
                404: function (response) {
                    that.ui.addEditMetadata.text(that.constants.addMetaTitle);
                    that.metadata = null;
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    }

});

module.exports = DocumentData;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-data.js
// module id = 393
// module chunks = 0